import { useEffect } from "react";

import { PreloadedQuery } from "react-relay";

import { pricingPageRelayQuery } from "@/__generated_contentful__/pricingPageRelayQuery.graphql";
import { PricingContentContextProviderRelay } from "@/components/wpl/pricing/src/pricing-content-context";
import { checkFeatureFlagGate, featureFlags } from "@/utils/feature-flags";
import { PricingContent } from "@/utils/pricing-queries/get-pricing-content";
import { UserLocale } from "@/utils/useGeoCurrency";

import { AppPricingData } from "../../../../contentful";
import { SoftwareBitbucketPricingPageTemplate } from "../../../../templates/software/bitbucket/pricing/software-bitbucket-pricing-page/src";

export type SoftwareBitbucketPricingPageProps = {
    pricing?: AppPricingData;
    countryCode?: UserLocale;
    pricingContent?: PricingContent;
    queryRef?: PreloadedQuery<pricingPageRelayQuery>;
};

export const SoftwareBitbucketPricingPageRelay = ({
    pricing,
    countryCode,
    pricingContent,
    queryRef
}: SoftwareBitbucketPricingPageProps) => {
    useEffect(() => {
        checkFeatureFlagGate(featureFlags.cpapiwdPricingAll);
    }, []);

    return (
        <PricingContentContextProviderRelay
            productId="bitbucket"
            pricingContent={pricingContent}
            queryRef={queryRef}
        >
            <div data-testid="bitbucket-pricing-page">
                <SoftwareBitbucketPricingPageTemplate
                    pricing={pricing}
                    countryCode={countryCode}
                />
            </div>
        </PricingContentContextProviderRelay>
    );
};
